import React, { useState } from "react";
import {Modal, Button,} from "antd";
import * as actionPage from "../../../../redux/actions/cancellationReason.actions";
import { validationErrors } from "../../../../utils/Helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const CancellationsReasonsDeleteModal = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setMBtnLoading(true);
      console.log(props.postdata.postid);
      await props.actionPage.deleteAction(props.postdata.postid)
      .then((res) => {
        if (res?.status === 200){
          props.handleCancel();
          props.refreshData();
        }
      });
    } catch (e) { validationErrors(e) } finally {
      setMBtnLoading(false);
    }
  };
  return (
    <Modal
      title="Cancellations Reasons Delete"
      visible={props.handlevisible}
      onCancel={props.handleCancel}
      footer={[
        <Button loading={MBtnLoading} onClick={props.handleCancel}>Cancel</Button>,
        <Button loading={MBtnLoading} onClick={onSubmit}>Submit</Button>,
      ]}
      style={{top: 20,}}
    >
      <p>Are you sure to delete</p>
      <p>ID: {props.postdata.displayid}</p>
      <p>Note: {props.postdata.value}</p>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CancellationsReasonsDeleteModal);